/* Seren × Apple — shared motion for sap sections.
   Reveals fire once, counters ease out, accordions retarget smoothly.
   Reduced motion → instant. */
(function () {
  var reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  function ease(t) {
    return 1 - Math.pow(1 - t, 3);
  }

  /* shared nav-height custom property (sticky offsets read it) */
  function setNavHeight() {
    var nav = document.querySelector(".nav");
    if (nav) {
      document.documentElement.style.setProperty(
        "--sap-nav-h",
        nav.offsetHeight + "px",
      );
    }
  }
  setNavHeight();
  window.addEventListener("resize", setNavHeight);

  /* accordion toggle — bound in every code path */
  document.addEventListener("click", function (e) {
    var btn = e.target.closest(".sap-acc-btn");
    if (!btn) return;
    var item = btn.closest(".sap-acc-item");
    if (!item) return;
    item.classList.toggle("open");
    btn.setAttribute(
      "aria-expanded",
      item.classList.contains("open") ? "true" : "false",
    );
  });

  /* no IntersectionObserver → reveal everything immediately and bail */
  if (!("IntersectionObserver" in window)) {
    var revealAll = function () {
      document
        .querySelectorAll("[data-sap-rv], .sap-bar")
        .forEach(function (el) {
          el.classList.add("in");
        });
      document.querySelectorAll("[data-sap-count]").forEach(function (el) {
        el.textContent =
          el.getAttribute("data-sap-count") +
          (el.getAttribute("data-sap-suffix") || "");
      });
    };
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", revealAll);
    } else {
      revealAll();
    }
    window.SapMotion = { arm: revealAll };
    return;
  }

  var io = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add("in");
          io.unobserve(e.target);
        }
      });
    },
    { rootMargin: "0px 0px -60px 0px", threshold: 0.05 },
  );

  var cio = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        cio.unobserve(e.target);
        var el = e.target;
        var target = parseFloat(el.getAttribute("data-sap-count"));
        if (isNaN(target)) return;
        var dec = (
          String(el.getAttribute("data-sap-count")).split(".")[1] || ""
        ).length;
        var suffix = el.getAttribute("data-sap-suffix") || "";
        if (reduce) {
          el.textContent = el.getAttribute("data-sap-count") + suffix;
          return;
        }
        var t0 = null;
        function frame(ts) {
          if (!t0) t0 = ts;
          var p = Math.min((ts - t0) / 900, 1);
          el.textContent = (target * ease(p)).toFixed(dec) + suffix;
          if (p < 1) requestAnimationFrame(frame);
        }
        requestAnimationFrame(frame);
      });
    },
    { threshold: 0.4 },
  );

  function arm(root) {
    (root || document)
      .querySelectorAll("[data-sap-rv], .sap-bar")
      .forEach(function (el) {
        if (!el.classList.contains("in")) io.observe(el);
      });
    (root || document)
      .querySelectorAll("[data-sap-count]")
      .forEach(function (el) {
        cio.observe(el);
      });
    (root || document)
      .querySelectorAll(".sap-marquee-track:not([data-dup])")
      .forEach(function (t) {
        t.setAttribute("data-dup", "1");
        t.innerHTML += t.innerHTML;
      });
  }

  /* Safety net: reveal anything already on screen without waiting for the
     observer. Browsers pause IntersectionObserver in background tabs, so a
     page opened in one (cmd-click, restored session) would otherwise render
     its above-the-fold content — including the buy box — fully transparent. */
  function revealVisible() {
    var h = window.innerHeight || document.documentElement.clientHeight;
    document
      .querySelectorAll("[data-sap-rv]:not(.in), .sap-bar:not(.in)")
      .forEach(function (el) {
        var r = el.getBoundingClientRect();
        if (r.top < h && r.bottom > 0) el.classList.add("in");
      });
    document.querySelectorAll("[data-sap-count]").forEach(function (el) {
      var r = el.getBoundingClientRect();
      if (
        r.top < h &&
        r.bottom > 0 &&
        el.textContent.trim().charAt(0) === "0"
      ) {
        cio.unobserve(el);
        el.textContent =
          el.getAttribute("data-sap-count") +
          (el.getAttribute("data-sap-suffix") || "");
      }
    });
  }

  function boot() {
    arm(document);
    setTimeout(revealVisible, 1400);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }

  document.addEventListener("visibilitychange", function () {
    if (!document.hidden) {
      arm(document);
      setTimeout(revealVisible, 300);
    }
  });

  /* theme editor: re-arm when sections load/reorder */
  document.addEventListener("shopify:section:load", function (e) {
    arm(e.target);
    setTimeout(revealVisible, 300);
  });

  window.SapMotion = { arm: arm, revealVisible: revealVisible };
})();
